import React from 'react';
import DOMPurify from "dompurify";

class JobSingleContent extends React.Component {
  render() {
    function decodeHTMLEntities(text) {
      if(text){
        var entities = [
          ['amp', '&'],
          ['apos', '\''],
          ['#x27', '\''],
          ['#x2F', '/'],
          ['#39', '\''],
          ['#47', '/'],
          ['lt', '<'],
          ['gt', '>'],
          ['nbsp', ' '],
          ['quot', '"']
      ];

      for (var i = 0, max = entities.length; i < max; ++i)
          text = text.replace(new RegExp('&'+entities[i][0]+';', 'g'), entities[i][1]);
      }
      return text;
  }
    const dirtyHTML = decodeHTMLEntities(this.props.job_data.description)
    return (
      <div className="col-sm-12 col-md-8 col-lg-8 article-text">
        <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(dirtyHTML)}}/>
      </div>
    )
  }
}

export default JobSingleContent;
